import React, { useEffect, useState } from "react";
import { FaHandPointLeft, FaHandPointRight } from "react-icons/fa";

const MAX_FUTURE_MONTHS = 2;

const Calendar = ({ setSelectedDateUsable, slots = [] }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const maxDate = new Date(
    today.getFullYear(),
    today.getMonth() + MAX_FUTURE_MONTHS,
    1
  );

  const getMonthName = (date) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  const prevMonth = () => {
    if (currentDate > minDate) {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      );
    }
  };

  const nextMonth = () => {
    if (currentDate < maxDate) {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
      );
    }
  };

  const getDaysInMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();

  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const renderDaysOfWeek = () => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return (
      <div className="grid grid-cols-7 text-center font-bold text-gray-900">
        {days.map((day, index) => (
          <div key={index} className="p-2">
            {day}
          </div>
        ))}
      </div>
    );
  };

  const renderCalendarCells = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);

    const bookedDates = slots.map((slot) =>
      new Date(slot.slot_date).toDateString()
    );

    const calendarDays = [];
    for (let i = 0; i < firstDay; i++) {
      calendarDays.push(<div key={`empty-${i}`} className="p-2"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const isToday = today.toDateString() === date.toDateString();
      const isSelected = selectedDate.toDateString() === date.toDateString();
      const isPast = date < today.setHours(0, 0, 0, 0);
      const isBooked = bookedDates.includes(date.toDateString());

      calendarDays.push(
        <div
          key={day}
          className={`px-2 py-4 text-center cursor-pointer rounded-full ${
            isSelected
              ? "bg-blue-500 text-white"
              : isToday
              ? "bg-gray-300 text-black font-semibold"
              : isPast
              ? "text-gray-400 cursor-not-allowed"
              : isBooked
              ? "border border-blue-300 text-blue-700"
              : "text-gray-700 hover:bg-blue-200"
          }`}
          onClick={() => !isPast && setSelectedDate(date)}
        >
          {day}
        </div>
      );
    }

    return <div className="grid grid-cols-7">{calendarDays}</div>;
  };

  useEffect(() => {
    const d = new Date(selectedDate);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const tempDate = `${year}-${month}-${day}`;
    setSelectedDateUsable(tempDate);
  }, [selectedDate]);

  return (
    <div className="max-w-md mx-auto bg-white border border-gray-300 rounded-lg overflow-hidden p-4">
      <div className="flex items-center justify-between p-4 bg-blue-500 rounded-t-lg">
        <button
          onClick={prevMonth}
          disabled={currentDate <= minDate}
          className={`text-gray-200 p-2 rounded-full transition-all duration-300 ${
            currentDate <= minDate
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-white hover:text-blue-500"
          }`}
        >
          <FaHandPointLeft className="text-xl" />
        </button>
        <h2 className="text-lg font-semibold text-white">
          {getMonthName(currentDate)}
        </h2>
        <button
          onClick={nextMonth}
          disabled={currentDate >= maxDate}
          className={`text-gray-200 p-2 rounded-full transition-all duration-300 ${
            currentDate >= maxDate
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-white hover:text-blue-500"
          }`}
        >
          <FaHandPointRight className="text-xl" />
        </button>
      </div>
      {renderDaysOfWeek()}
      {renderCalendarCells()}
    </div>
  );
};

export default Calendar;
